import { render, staticRenderFns } from "./StaffModal.vue?vue&type=template&id=e124aa7c"
import script from "./StaffModal.vue?vue&type=script&lang=js"
export * from "./StaffModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports